import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Button from '@chama/ui-components/components/ButtonNew';

import './AddProductFormActions.css';

export default function AddProductFormActions({
  onHideAddProductForm,
  onResetForm,
  onSubmitForm,
  isSavingDisabled,
}) {
  const handleCancel = () => {
    onHideAddProductForm();
    onResetForm();
  };

  return (
    <div className="AddProductsFormActions">
      <Button variant="secondary" onClick={handleCancel}>
        <FormattedMessage id="cancel" />
      </Button>
      <Button variant="primary" onClick={onSubmitForm} isDisabled={isSavingDisabled}>
        <FormattedMessage id="save" />
      </Button>
    </div>
  );
}
AddProductFormActions.propTypes = {
  isSavingDisabled: PropTypes.bool.isRequired,
  onHideAddProductForm: PropTypes.func.isRequired,
  onResetForm: PropTypes.func.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/ProductsAddProductForm/AddProductFormActions/AddProductFormActions.jsx